import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckPermissions, DownloadFile } from './Shared';

const ReportItemsOnHireSummaryData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    
    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunItemsOnHireReports");
        if (hasPermission) {
            setLoading(false);
        } else {
            navigate("/accessdenied")
        }
    }

    const exportReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data
        exportRpt(); 
    }

    const exportRpt = async () => {
        const apiURL = 'RunItemsOnHireSummaryReport';
        var filename = "Items On Hire Summary.xlsx";
        await DownloadFile(apiURL, filename);
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Items On Hire Summary Report</h1>
            </div>
            <div>
                <button className="defaultbutton" type='button' onClick={exportReport}>Export to Excel</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportItemsOnHireSummaryData;